import { Component } from '@angular/core';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss'],
})
/**
 * Loading Component for onboarding
 */
export class LoadingComponent {}
